

export default cjs;
import packageResult from 'utils/packageResult';
import hasOwnProp from 'utils/hasOwnProp';
import transformBody from './utils/transformBody';
import { req } from 'utils/mappers';
function cjs(mod, options) {
	var seen = {};

	// Create block of require statements
	var importBlock = mod.imports.map(function (x) {
		if (!hasOwnProp.call(seen, x.path)) {
			seen[x.path] = true;

			if (x.isEmpty) {
				return req(x.path) + ';';
			}

			return 'var ' + x.name + ' = ' + req(x.path) + ';';
		}
	}).filter(Boolean).join('\n');

	transformBody(mod, mod.body, {
		header: importBlock,
		_evilES3SafeReExports: options._evilES3SafeReExports
	});

	if (options.useStrict !== false) {
		mod.body.prepend("'use strict';\n\n").trimLines();
	}

	return packageResult(mod, mod.body, options, 'toCjs');
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/strictMode/cjs.js.01-babel.map